import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { compare } from '@nu-art/ts-common';
import { _className, EventType_Create, EventType_Update, LL_H_C, LL_V_L, ModuleFE_Dialog, performAction, SimpleListAdapter, TS_Dialog, TS_DropDown, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_Book, ModuleFE_Reference } from '../../../../_entity.js';
export class Dialog_BookEditor extends TS_Dialog {
    // ######################### Static #########################
    static show(onRefUpsertCallback, reference) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_BookEditor, { onRefUpsertCallback: onRefUpsertCallback, reference: reference }), closeOverlayOnClick: () => false });
    }
    static copy(onRefUpsertCallback, reference) {
        const ref = { ...reference };
        delete ref._id;
        ModuleFE_Dialog.show({ content: _jsx(Dialog_BookEditor, { onRefUpsertCallback: onRefUpsertCallback, reference: ref }), closeOverlayOnClick: () => false });
    }
    static defaultProps = {
        dialogId: 'dialog-book-editor',
    };
    // ######################### LifeCycle #########################
    __onReferencesUpdated = async (...params) => {
        const originRef = this.props.reference;
        switch (params[0]) {
            case EventType_Create:
            case EventType_Update:
                await this.props.onRefUpsertCallback(params[1], originRef);
                ModuleFE_Dialog.close();
                break;
        }
    };
    deriveStateFromProps(nextProps, state) {
        const books = ModuleFE_Book.cache.all();
        if (!state.selected && nextProps.reference) {
            state.selected = [books.findIndex(book => book._id === nextProps.reference.data.bookId), ...nextProps.reference.data.path, -1];
        }
        else {
            state.selected = [-1];
        }
        state.page ??= nextProps.reference?.data.page || 0;
        state.paragraph = nextProps.reference?.data.paragraph || '';
        state.rootStruct ??= {
            name: 'Books',
            items: books,
            itemsType: 'book'
        };
        return state;
    }
    // ######################### Logic #########################
    canBeSaved = () => {
        return true;
    };
    handleSave = async () => {
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            try {
                const path = this.state.selected.slice(1, this.state.selected.length - 1);
                const data = {
                    bookId: this.state.rootStruct.items[this.state.selected[0]]._id,
                    path: path,
                    paragraph: this.state.paragraph || '',
                    page: this.state.page || -1,
                };
                const ref = this.props.reference || {
                    type: 'book',
                    uid: '',
                };
                ref.data = data;
                ModuleFE_Reference.v1.upsert(ref).execute();
            }
            catch (e) {
                this.logError(e);
            }
            finally {
                this.setState({ dialogIsBusy: false });
            }
        }, { type: 'notification', notificationLabels: 'Saving Book Reference' });
    };
    // ######################### Render #########################
    renderSection(i, structure, selected) {
        const items = structure.items;
        if (!structure.itemsType || !items)
            return '';
        const adapter = SimpleListAdapter(items, item => _jsx("div", { className: 'node-data', children: item.item.name }));
        return _jsx(TS_PropRenderer.Vertical, { className: 'dialog__main__section-content', label: 'Select ' + structure.itemsType, children: _jsx(TS_DropDown, { adapter: adapter, selected: selected, onSelected: val => {
                    const newSelected = this.state.selected.slice(0, i);
                    const matchingVal = items.find(item => compare(item, val));
                    newSelected.push(items.indexOf(matchingVal), -1);
                    this.setState({ selected: newSelected });
                } }) });
    }
    renderPageInput() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Enter page', className: 'dialog__main__section', children: _jsx(TS_Input, { type: 'number', value: this.state.page ? `${this.state.page}` : '', onChange: val => {
                    this.setState({ page: Number(val) });
                } }) });
    }
    renderParagraphInput() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Enter paragraph', className: 'dialog__main__section', children: _jsx(TS_Input, { type: 'text', value: this.state.paragraph || '', onChange: val => {
                    this.setState({ paragraph: val });
                } }) });
    }
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'header__title', children: [this.props.reference?._id ? 'Edit' : 'Add', " Reference"] }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() }) })] });
    };
    renderBody = () => {
        const rootStruct = this.state.rootStruct;
        const reduce = this.state.selected?.reduce((toRet, selectedIndex, pathIndex) => {
            if (!toRet.struct?.items)
                return toRet;
            const parentStruct = toRet.struct;
            toRet.struct = toRet.struct.items[selectedIndex];
            toRet.renderer.push(_jsx(LL_V_L, { className: 'dialog__main__section', children: this.renderSection(pathIndex, parentStruct, toRet.struct) }, pathIndex));
            return toRet;
        }, { struct: rootStruct, renderer: [] });
        return _jsxs(_Fragment, { children: [reduce?.renderer, _jsxs(LL_H_C, { className: 'lower-inputs', children: [this.renderPageInput(), this.renderParagraphInput()] })] });
    };
    buttons = () => {
        return {
            right: [
                {
                    content: 'Cancel',
                    onClick: () => ModuleFE_Dialog.close(),
                },
                {
                    content: 'Save',
                    className: _className(this.canBeSaved() ? 'desired-action-button' : ''),
                    disabled: !this.canBeSaved() || this.state.dialogIsBusy,
                    onClick: this.handleSave,
                }
            ]
        };
    };
}
//# sourceMappingURL=Dialog_BookEditor.js.map